module.exports = __webpack_public_path__ + "static/img/9.a50c7a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/9.png
// module id = JtWz
// module chunks = 0